import { render } from "./move-enrolments-to-organisation.vue?vue&type=template&id=327767c0&ts=true"
import script from "./move-enrolments-to-organisation.ts?vue&type=script&lang=ts&external"
export * from "./move-enrolments-to-organisation.ts?vue&type=script&lang=ts&external"

import "./move-enrolments-to-organisation.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__